import axios from "axios";

export const API_URL = '/api/v1'
export const HEADER_FORM_DATA = {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
}

/**
 * Приводит ответ к стандартной структуре списка
 * @param res
 * @return {{data, meta: {last_page: number, current_page: number}}}
 */
export const formatToResponsePagination = res => {
  return {
    data: res.data,
    meta: {
      last_page: 1,
      current_page: 1
    }
  }
}

export const getContentTypeHeader = (data) => {
  return data instanceof FormData ? HEADER_FORM_DATA : null
}

export const get = (query, config) => {

  return sendQuery({
    method: 'get',
    url: `${API_URL}${query}`,
    ...config
  })
}

export const post = (query, data, config) => {

  return sendQuery({
    method: 'post',
    url: `${API_URL}${query}`,
    data,
    ...config
  })
}

export const put = (query, data, config) => {

  return sendQuery({
    method: 'put',
    url: `${API_URL}${query}`,
    data,
    ...config
  })
}

export const deleteMethod = (query, data, config) => {
  return sendQuery({
    method: 'delete',
    url: `${API_URL}${query}`,
    data,
    ...config
  })
}

export const sendQuery = (config) => {
  return axios(config)
}
